
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, CreateCallModal, CallCard } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

@Component({
  components: {
    NavBar,
    CreateCallModal,
    CallCard
  }
})
export default class ScheduleCallView extends Vue {
  data () {
    return {
      isLoading: false,
      createCallModalDisplay: false,
      activeTab: 1,
      completedSearch: '',
      completedCalls: [],
      upcomingSearch: '',
      upcomingCalls: [],
      isAllowedToCreateCall: false
    }
  }

  mounted () {
    this.getLastCalls()
    this.getUpcomingCalls()
    var roles = store.getters.getUserRoles
    roles.map(e => {
      this.isAllowedToCreateCall = this.isAllowedToCreateCall || e.includes('TEACHER') || e.includes('TUTOR')
      return 0
    })
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  async searchCompletedCalls () {
    await this.getLastCalls()
  }

  clearSearchCompletedCalls () {
    this.completedSearch = ''
  }

  async getLastCalls () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getLastCalls/${this.completedSearch}`))
      resp.map((item) => {
        item.scheduleTo = new Date(item.scheduleTo)
        if (item.start) {
          item.start = new Date(item.start)
        }
        if (item.end) {
          item.end = new Date(item.end)
        }

        return 0
      })
      this.completedCalls = resp
      this.isLoading = false
    } catch (e) {
      this.completedCalls = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get completed calls.',
        canCancel: false
      })
    }
  }

  async searchUpcomingCalls () {
    await this.getUpcomingCalls()
  }

  clearSearchUpcomingCalls () {
    this.upcomingSearch = ''
  }

  async getUpcomingCalls () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUpcomingCalls/${this.upcomingSearch}`))
      resp.map((item) => {
        item.scheduleTo = new Date(item.scheduleTo)
        if (item.start) {
          item.start = new Date(item.start)
        }
        if (item.end) {
          item.end = new Date(item.end)
        }

        return 0
      })
      this.upcomingCalls = resp
      this.isLoading = false
    } catch (e) {
      this.upcomingCalls = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get upcoming calls.',
        canCancel: false
      })
    }
  }

  openNewCallModal () {
    this.createCallModalDisplay = true
  }

  async newCallCreated () {
    await this.getUpcomingCalls()
    this.createCallModalDisplay = false
  }
}
